import React, {useContext, useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import { Button, Modal } from "react-bootstrap";
import notify from "../../../utils/notification";
import { getAdminAllSubCategory } from "../../../services/adminApiService/adminSubCategory/AdminSubCategory";
import { UploadAdminExcel } from "../../../services/adminApiService/organisationApi/OrganisationApiService";
import * as XLSX from "xlsx";
import "./style.css";
import useSearchValue from "../../../hooks/useSearchValue";
import { LocationContext } from "../../../context/LocationContext";
import { useCategoryFilter } from "../../../context/CategoryFilterContext";

const ImportExcelModal = ({
  showImportModal,
  setShowImportModal,
  adminCategoryTypeData,
  getOrganisationListApi,
  currentPage,
  perPage,
  selectedStatus,
  setCurrentPage,
 selectedSportsId
}) => {
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState([]);
  const fileInputRef = useRef(null);
  const [excelErrors, setExcelErrors] = useState([]);

  const [addFormData, setAddFormData] = useState({
    user_category_main: "2",
    category_type: "",
    sub_category_type: "",
    excelFile: file,
  });


  const [showLoader, setShowLoader] = useState(false);
  const [subCategorylistData, setSubCategorylistData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downLoadbtndisplay, setDownLoadbtndisplay] = useState(false);
  const {debouncedSearchValue} = useSearchValue();
    const { selectedDistrictId ,setSelectedDistrictId} = useContext(LocationContext);
      const { selectedSubCategoryId,setSelectedSubCategoryId } = useCategoryFilter();
  const handleAddFormChange = async (event) => {
    const { name, value } = event.target;

    setAddFormData((prevFormData) => {
      let updatedFormData = { ...prevFormData, [name]: value };

      // Reset sub_category_type when category_type changes
      if (name === "category_type") {
        updatedFormData.sub_category_type = ""; // Clear previous sub-category value
      }

      return updatedFormData;
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  

    if (name === "category_type") {
      // setDownLoadbtndisplay(true);
      await getAdminSubCategoryListApi(value);
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/SampleSheet.xlsx";
    link.download = "SampleSheet.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const validateExcelData = (data) => {
    const errors = [];
    // Check if the data is empty
    if (!data || data.length === 0) {
      errors.push("Uploaded Excel file is empty.");
      return errors; // Return early to avoid unnecessary checks
    }
    data.forEach((row, index) => {
      const registrationNumber = String(
        row["Registration Number"] || ""
      ).trim();
      const nameOfInstitution = String(row["Name of Institution"] || "").trim();
      const AddressFullPostalAddress = String(
        row["Address (Full Postal Address)"] || ""
      ).trim();
      const institutionEmail = String(row["Institution Email"] || "").trim();
      const ContactPersonName = String(row["Contact Person Name"] || "").trim();
      const ContactPersonDesignation = String(
        row["Contact Person Designation"] || ""
      ).trim();
      const contactPersonContactNumber = String(
        row["Contact Person Contact Number"] || ""
      ).trim();
      const AffiliatedSportsBody = String(
        row["Affiliated Sports Body"] || ""
      ).trim();
      if (registrationNumber === "") {
        errors.push(`Row ${index + 1}: Registration Number must not be empty.`);
      }
      if (nameOfInstitution === "") {
        errors.push(`Row ${index + 1}: Name of Institution must not be empty.`);
       
      }
      if (AddressFullPostalAddress === "") {
        errors.push(
          `Row ${index + 1
          }: Name of Address Full Postal Address must not be empty.`
        );
      }

      if (institutionEmail === "") {
        errors.push(`Row ${index + 1}: Name of Institution Email must not be empty.`);
      } else if (!/^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(institutionEmail)) {
        errors.push(`Row ${index + 1}: Institution Email is invalid.`);
      }

      if (ContactPersonName === "") {
        errors.push(
          `Row ${index + 1}: Name of Contact Person Name must not be empty.`
        );
      }
    
      if (ContactPersonDesignation === "") {
        errors.push(
          `Row ${index + 1
          }: Designation of contact person must not be empty.`
        );
      }
    
      if (contactPersonContactNumber === "") {
        errors.push(
          `Row ${index + 1
          }: Contact number of contact person must not be empty.`
        );
      }
      else if (!/^\d{10}$/.test(contactPersonContactNumber)) {
        errors.push(
          `Row ${index + 1
          }: Contact Person Contact Number must be a 10-digit number.`
        );
      }

      if (AffiliatedSportsBody === "") {
        errors.push(
          `Row ${index + 1}: Name of Affiliated Sports Body must not be empty.`
        );
      }
      
    });
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple clicks while loading

    setLoading(true);

    // Disable button and show loading
    const { user_category_main, category_type, sub_category_type } = addFormData;
    let formIsValid = true;
    const newErrors = {};
   
    if (!user_category_main) {
      newErrors.user_category_main = "User Main Category is required.";
      formIsValid = false;
    }
    if (!category_type) {
      newErrors.category_type = "Category Type is required.";
      formIsValid = false;
    }
    if (!sub_category_type) {
      newErrors.sub_category_type = "Sub Category is required.";
      formIsValid = false;
    }
    if (!file) {
      newErrors.file = "Please select an Excel file to upload.";
      formIsValid = false;
    }

    setErrors(newErrors);

    if (!formIsValid) {
      setLoading(false);
      return;
    }
    setShowLoader(true);
    readXlFile();
  };

  const uplodData = async () => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("user_category_main", addFormData.user_category_main);
    formData.append("category_type", addFormData.category_type);
    formData.append("sub_category_type", addFormData.sub_category_type);

    try {
      const response = await UploadAdminExcel(formData);
      if (response?.status === 200) {
        if (response.data.failedRows && response.data.failedRows.length > 0) {
          setErrors(
            response.data.failedRows.map(
              (error) => `Row ${error.row_number}: ${error.errors.join(", ")}`
            )
          );
          setShowImportModal(false);
          setCurrentPage(1);

          const errorHTML = `
                     <h4 className="inster_row"> ${response?.data?.insertedRows
            } Number of Rows Successfully Inserted Into Database</h4>
                        <div class="alert alert-danger">
                        
                            <h5>However, the following rows had issues:</h5>
                           
                            ${response?.data?.failedRows
              ?.map(
                (error, index) => `
                                <div key=${index}>
                                    <strong>Row ${error?.row_number}:</strong>
                                    <ul>
                                        ${error?.errors
                    ?.map(
                      (err, idx) =>
                        `<li key=${idx}>${err}</li>`
                    )
                    .join("")}
                                    </ul>
                                </div>
                            `
              )
              .join("")}
                        </div>
                    `;

          swal({
            title: "Upload Excel was successful!",
            content: {
              element: "div",
              attributes: {
                innerHTML: errorHTML,
              },
            },
            icon: "success",
          });
        } else {
          setErrors([]);
          swal("Success", "Upload Excel was successful!", "success");

        }
        getOrganisationListApi(perPage, currentPage, selectedStatus,debouncedSearchValue,selectedDistrictId,selectedSubCategoryId,selectedSportsId); // Call the listing API to update the page
        setShowImportModal(false);
      } else {
        notify("error", response.data.message);
        setErrors([]);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        notify("error", error.response.data.message);
      } else {
        notify("error", "An unexpected error occurred. Please try again.");
      }
      setErrors([]);
    } finally {
      setLoading(false);
      setShowLoader(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return; // Prevents errors if no file is selected

    const validFileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!validFileTypes.includes(selectedFile.type)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        file: "Please upload a valid Excel file.",
      }));
      setFile(null);
      setExcelErrors([]); // Clear excelErrors when file type is invalid
      setLoading(false); // Reset loading state
      setShowLoader(false); // Ensure loader is also reset
    } else {
      setFile(selectedFile);

      // ✅ Clear the file error when a valid file is selected
      setErrors((prevErrors) => {
        const { file, ...rest } = prevErrors; // Remove 'file' from errors
        return rest;
      });
      setLoading(false); // Reset loading state
      setShowLoader(false); // Hide the loader
    }
  };


  const readXlFile = () => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(sheet);
      const validationErrors = validateExcelData(data);
      if (validationErrors.length > 0) {
        setExcelErrors(validationErrors);
        setLoading(false); // Reset loading if Excel validation fails
        setShowLoader(false);
        // setErrors((prevErrors) => ({ ...prevErrors, file: validationErrors.join(', ') }));
        setErrors([]);
      } else {
        setExcelErrors([]);
        setErrors((prevErrors) => ({ ...prevErrors, file: "" }));
        uplodData();
      }
      fileInputRef.current.value = "";
    };
    reader.readAsBinaryString(file);
    fileInputRef.current.value = "";
  };

  const DiscardHandler = () => {
    setShowImportModal(false);
    setLoading(false);
    setDownLoadbtndisplay(false);
    setErrors([]);
    setExcelErrors([]);


  };

  const getAdminSubCategoryListApi = async (categoryTypeId) => {
    try {
      const response = await getAdminAllSubCategory(categoryTypeId);
      setSubCategorylistData(response?.data);
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  useEffect(() => {
    if (showImportModal) {
      setErrors([]); // Reset errors when the modal is opened
      setExcelErrors([]); // Reset Excel errors when the modal is opened
    }
    getAdminSubCategoryListApi();
  }, [showImportModal]);

  useEffect(() => {
    if (!showImportModal) {
      setAddFormData((prevData) => ({
        ...prevData,
        category_type: "",
        sub_category_type: "",
      }));
      setFile(null);
      setErrors({});
    }
  }, [showImportModal]);

  return (
    <>
      <Modal
        className="modal fade"
        show={showImportModal}
        onHide={setShowImportModal}
      >
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Import Excel</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={DiscardHandler}
                  data-dismiss="modal"
                >
                  <span></span>
                </button>
              </div>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div className="row">
                      <div className="form-group mb-3 col-md-6">
                        <label className="text-black font-w500">
                          User Main Category{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="contact-name">
                          <select
                            defaultValue="2"
                            name="user_category_main"
                            onChange={handleAddFormChange}
                            id="inputState"
                            className="form-control"
                            disabled
                          >
                            {/* <option>Select Category Type</option> */}
                            <option value="2">Institution </option>
                          </select>
                          {errors.user_category_main && (
                            <span className="validation-text text-danger">
                              {errors.user_category_main}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label className="text-black font-w500">
                          Select Category Type{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="contact-name">
                          <select
                            defaultValue=""
                            name="category_type"
                            onChange={handleAddFormChange}
                            id="inputState"
                            className="form-control"
                          >
                            <option value="">Select Category Type</option>
                            {adminCategoryTypeData?.data?.map((item) => (
                              <option key={item?.id} value={item?.id}>
                                {item?.category_name}
                              </option>
                            ))}
                          </select>
                          {errors.category_type && (
                            <span className="validation-text text-danger">
                              {errors.category_type}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group mb-3 col-md-6">
                        <label className="text-black font-w500">
                          Select Sub Category
                          <span className="text-danger">*</span>
                        </label>
                        <div className="contact-name">
                          <select
                            defaultValue=""
                            name="sub_category_type"
                            onChange={handleAddFormChange}
                            id="inputState"
                            className="form-control"
                          >
                            <option value="">Select Sub Category</option>
                            {subCategorylistData && Array.isArray(subCategorylistData) && subCategorylistData.map((item) => (
                              <option key={item?.id} value={item?.id}>
                                {item?.category_name_view}
                              </option>
                            ))}

                          </select>
                          {errors.sub_category_type && (
                            <span className="validation-text text-danger">
                              {errors.sub_category_type}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="form-group mb-3 col-md-6">
                        <label
                          htmlFor="formFile"
                          className="form-label text-black font-w500"
                        >
                          Upload Excel <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          name="excelFile"
                          id="formFile"
                          onChange={handleFileChange}
                          ref={fileInputRef}
                        />
                        {errors.file && (
                          <span className="validation-text text-danger">
                            {errors.file}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <div>
                  <Button
                    variant="primary"
                    className="mx-2"
                    onClick={handleDownload}
                  >
                    Download Excel
                  </Button>
                </div>
                <div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="btn btn-primary mx-2"
                    onClick={handleSubmit}
                  >
                    {loading ? "Loading..." : "Submit"}

                  </button>
                  <button
                    type="button"
                    onClick={DiscardHandler}
                    className="btn btn-danger"
                  >
                    {" "}
                    <i className="flaticon-delete-1"></i> Discard
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {excelErrors.length > 0 && (
          <div className="alert alert-danger">
            <h5>Validation Errors:</h5>
            <ul>
              {excelErrors.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </div>
        )}

        {showLoader && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default React.memo(ImportExcelModal);
